import { render, staticRenderFns } from "./BaseExtractedDetails.vue?vue&type=template&id=1ddeaa53&scoped=true"
import script from "./BaseExtractedDetails.vue?vue&type=script&lang=js"
export * from "./BaseExtractedDetails.vue?vue&type=script&lang=js"
import style0 from "./BaseExtractedDetails.vue?vue&type=style&index=0&id=1ddeaa53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddeaa53",
  null
  
)

export default component.exports